import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import WidgetSelectors from '../../../../../../Modules/Redux/Pages/Widget/WidgetSelectors';
import { isBetween } from '../../../../../../Utils/Maths';
import { MoonIcon } from '../../../../Components/MoonIcon/MoonIcon';

export const WidgetMoonCounter: FunctionComponent = () => {
  const collectedMoons: number = useSelector(WidgetSelectors.collectedMoonsCount);
  const remainingMoons: number = useSelector(WidgetSelectors.remainingMoonsCount);
  const primaryColor: string = useSelector(WidgetSelectors.primaryColor);
  const secondaryColor: string = useSelector(WidgetSelectors.secondaryColor);
  const scale: number = useSelector(WidgetSelectors.scale);

  return (
    <div className="h-stack items-center justify-between">
      <div className={classNames('h-stack items-center', isBetween(scale, 0, 50) ? 'space-x-2' : 'space-x-4')}>
        <MoonIcon style={{ width: `${25 + scale}px`, height: `${25 + scale}px` }} color={primaryColor} />
        <h2
          className="text-8xl font-bold text-tint transition-color-widget"
          style={{ fontSize: `${10 + scale}px`, lineHeight: '100%', color: primaryColor }}
        >
          {collectedMoons}
        </h2>
      </div>
      <h2
        className="text-8xl font-bold text-tint transition-color-widget"
        style={{ fontSize: `${10 + scale}px`, lineHeight: '100%', color: secondaryColor }}
      >
        {remainingMoons}
      </h2>
    </div>
  );
};
